import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

// Pages
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import ArticlePage from "@/pages/ArticlePage";
import WorldstarPage from "@/pages/WorldstarPage";
import CheckYourClaimsPage from "@/pages/CheckYourClaimsPage";
import AllStoriesPage from "@/pages/AllStoriesPage";
import MerchPage from "@/pages/MerchPage";
import SearchPage from "@/pages/SearchPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import EditorialPolicyPage from "@/pages/EditorialPolicyPage";
import TermsPage from "@/pages/TermsPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminArticleForm from "@/pages/admin/AdminArticleForm";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminAITools from "@/pages/admin/AdminAITools";

// Context
import { AuthProvider } from "@/context/AuthContext";
import { AdProvider } from "@/context/AdContext";
import PushBanner from "@/components/PushBanner";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <AdProvider>
          <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/allstories" element={<AllStoriesPage />} />
            <Route path="/worldstar" element={<WorldstarPage />} />
            <Route path="/check-your-claims" element={<CheckYourClaimsPage />} />
            <Route path="/merch" element={<MerchPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/editorial-policy" element={<EditorialPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/category/:category" element={<CategoryPage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/articles" element={<AdminArticles />} />
            <Route path="/admin/articles/new" element={<AdminArticleForm />} />
            <Route path="/admin/articles/edit/:id" element={<AdminArticleForm />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/subscribers" element={<AdminSubscribers />} />
            <Route path="/admin/ai-tools" element={<AdminAITools />} />

            {/* Catch-all: any unknown/deleted page redirects to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <PushBanner />
          <Toaster position="top-right" theme="dark" richColors closeButton />
        </BrowserRouter>
      </AdProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
